import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AddressType } from '../../_common/_enum/module.enum';
import { API_URL } from 'src/app/_common/constants';
import { Submission } from 'src/app/submissions/_models/submission';
import { SubmissionsService } from 'src/app/submissions/_services/submissions.service';
import { DiceQuote } from 'src/app/dice/_models/dice-quote';
import { DiceService } from 'src/app/dice/_services/dice.service';

@Component({
  selector: 'app-business-lookup',
  templateUrl: './business-lookup.component.html',
  styleUrls: ['./business-lookup.component.scss']
})
export class BusinessLookupComponent implements OnInit {

  @Input() isBusinessLookup: boolean;
  @Input() businessStateSelected: string;
  @Input() dnbEventsModel: any;
  @Output() isBusinessLookupOutput = new EventEmitter<boolean>();

  private referenceData: any;
  private lookupAPI = API_URL.BusinessLookup; //Using it in HTML

  private isDice: boolean;
  private businessLookupModel: any;
  private businessLookupData: any;

  @ViewChild("businessLookupForm", {static: false}) businessLookupForm: NgForm;

  constructor(private submissionService: SubmissionsService, private diceService: DiceService) { }

  ngOnInit() {
    this.isDice = (history && history.state && history.state.isDice);
    this.referenceData = this.isDice ? this.diceService.referenceData : this.submissionService.referenceData;
    this.businessLookupModel = this.isDice ? this.diceService.diceQuote : this.submissionService.submission;
    this.businessLookupData = this.isDice ? this.businessLookupModel : this.businessLookupModel.submissionData;
    this.businessStateSelected = this.businessLookupData.searchState;

    console.log('this.businessLookupData :: ', this.businessLookupData);
  }

  updateStateVal(_selectedval) {
    this.businessStateSelected = _selectedval;
  }

  gotoBasicInfo ($event) {
    console.log('Business LKP Component : ', this.isBusinessLookup);
    this.isBusinessLookupOutput.emit($event);
  }
}